import {ReactNode, Suspense, useEffect, useState} from "react";
import {FormProvider, Path} from "react-hook-form";

import {Loader} from "@pg-design/loader-module";
import {useEmailVerificationApiError} from "@pg-rp/email-with-verification";

import {useVerifyEmailQuery} from "../../../email_verification/api/email_verification_api";
import {IBaseDefaultValues, IUseLeadFormConfig, IUseLeadFormReturn, useLeadForm} from "../../hooks/use_lead_form";
import {LeadFormSubmitFooter} from "./LeadFormSubmitFooter";
import {LeadFormUserDataFields} from "./LeadFormUserDataFields";

export interface ILeadFormContext<TExtraValues extends Record<string, unknown> = Record<string, never>> {
    formMethods: IUseLeadFormReturn<TExtraValues>["formMethods"];
    applicationData: IUseLeadFormReturn<TExtraValues>["applicationData"];
}

interface ILeadFormProps<TExtraValues extends Record<string, unknown> = Record<string, never>> {
    config: IUseLeadFormConfig<TExtraValues>;
    children?: (ctx: ILeadFormContext<TExtraValues>) => ReactNode;
    customHeader?: ReactNode;
    buttonText: string;
    showRodoInFooter?: boolean;
    formWrapperClassName?: string;
    footerWrapperClassName?: string;
}

export const LeadFormBase = <TExtraValues extends Record<string, unknown> = Record<string, never>>(props: ILeadFormProps<TExtraValues>) => {
    const {config, children, customHeader, buttonText, showRodoInFooter = true, formWrapperClassName, footerWrapperClassName} = props;

    const {formMethods, isSending, onSubmit, onInteraction, applicationData, vendorName, offerPersonalDataProcessorName, rodoLinks} =
        useLeadForm<TExtraValues>(config);

    const [email, setEmail] = useState<string | null>(null);
    const {data, error, isLoading, isFetching} = useVerifyEmailQuery({email: email || ""}, {skip: !email});
    const apiError = useEmailVerificationApiError({errorData: error});
    const ignoreVerification = !!formMethods.formState.defaultValues?.email && !email;
    const disableSubmitButton =
        (!ignoreVerification && !data) || formMethods.formState.isSubmitting || !formMethods.formState.isValid || isLoading || isFetching;
    useEffect(() => {
        if (!apiError.isValid) {
            formMethods.setError("email" as Path<IBaseDefaultValues & TExtraValues>, {message: apiError.message});
        }
    }, [apiError]);

    const footerContent = (
        <LeadFormSubmitFooter
            sendDisabled={disableSubmitButton}
            isSending={isSending}
            buttonText={buttonText}
            vendorName={showRodoInFooter ? vendorName : undefined}
            offerPersonalDataProcessorName={showRodoInFooter ? offerPersonalDataProcessorName : undefined}
            rodoLinks={showRodoInFooter ? rodoLinks : undefined}
        />
    );

    return (
        <div className={formWrapperClassName}>
            <Suspense fallback={<Loader />}>
                <FormProvider {...formMethods}>
                    <form onSubmit={formMethods.handleSubmit(onSubmit as (values: Record<string, unknown>) => Promise<void>)} onClick={() => onInteraction()}>
                        {customHeader}

                        <LeadFormUserDataFields verificationData={data} verificationTrigger={setEmail} />

                        {children?.({formMethods, applicationData})}

                        {footerWrapperClassName ? <div className={footerWrapperClassName}>{footerContent}</div> : footerContent}
                    </form>
                </FormProvider>
            </Suspense>
        </div>
    );
};
import {ReactNode, Suspense, useEffect, useState} from "react";
import {FormProvider, Path} from "react-hook-form";

import {Loader} from "@pg-design/loader-module";
import {useEmailVerificationApiError} from "@pg-rp/email-with-verification";

import {useVerifyEmailQuery} from "../../../email_verification/api/email_verification_api";
import {IBaseDefaultValues, IUseLeadFormConfig, IUseLeadFormReturn, useLeadForm} from "../../hooks/use_lead_form";
import {LeadFormSubmitFooter} from "./LeadFormSubmitFooter";
import {LeadFormUserDataFields} from "./LeadFormUserDataFields";

export interface ILeadFormContext<TExtraValues extends Record<string, unknown> = Record<string, never>> {
    formMethods: IUseLeadFormReturn<TExtraValues>["formMethods"];
    applicationData: IUseLeadFormReturn<TExtraValues>["applicationData"];
}

interface ILeadFormProps<TExtraValues extends Record<string, unknown> = Record<string, never>> {
    config: IUseLeadFormConfig<TExtraValues>;
    children?: (ctx: ILeadFormContext<TExtraValues>) => ReactNode;
    customHeader?: ReactNode;
    buttonText: string;
    showRodoInFooter?: boolean;
    formWrapperClassName?: string;
    footerWrapperClassName?: string;
}

export const LeadFormBase = <TExtraValues extends Record<string, unknown> = Record<string, never>>(props: ILeadFormProps<TExtraValues>) => {
    const {config, children, customHeader, buttonText, showRodoInFooter = true, formWrapperClassName, footerWrapperClassName} = props;

    const {formMethods, isSending, onSubmit, onInteraction, applicationData, vendorName, offerPersonalDataProcessorName, rodoLinks} =
        useLeadForm<TExtraValues>(config);

    const [email, setEmail] = useState<string | null>(null);
    const {data, error, isLoading, isFetching} = useVerifyEmailQuery({email: email || ""}, {skip: !email});
    const apiError = useEmailVerificationApiError({errorData: error});
    const ignoreVerification = !!formMethods.formState.defaultValues?.email && !email;
    const disableSubmitButton =
        (!ignoreVerification && !data) || formMethods.formState.isSubmitting || !formMethods.formState.isValid || isLoading || isFetching;
    useEffect(() => {
        if (!apiError.isValid) {
            formMethods.setError("email" as Path<IBaseDefaultValues & TExtraValues>, {message: apiError.message});
        }
    }, [apiError]);

    const footerContent = (
        <LeadFormSubmitFooter
            sendDisabled={disableSubmitButton}
            isSending={isSending}
            buttonText={buttonText}
            vendorName={showRodoInFooter ? vendorName : undefined}
            offerPersonalDataProcessorName={showRodoInFooter ? offerPersonalDataProcessorName : undefined}
            rodoLinks={showRodoInFooter ? rodoLinks : undefined}
        />
    );

    return (
        <div className={formWrapperClassName}>
            <Suspense fallback={<Loader />}>
                <FormProvider {...formMethods}>
                    <form onSubmit={formMethods.handleSubmit(onSubmit as (values: Record<string, unknown>) => Promise<void>)} onClick={() => onInteraction()}>
                        {customHeader}

                        <LeadFormUserDataFields verificationData={data} verificationTrigger={setEmail} />

                        {children?.({formMethods, applicationData})}

                        {footerWrapperClassName ? <div className={footerWrapperClassName}>{footerContent}</div> : footerContent}
                    </form>
                </FormProvider>
            </Suspense>
        </div>
    );
};
